export default __webpack_public_path__ + "static/media/gotham-book.5d301656.ttf";